import React, { useContext, useEffect, useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux'

import _ from 'lodash'
import { ParallaxProvider } from "react-scroll-parallax";

import { WidgetsContext, Widget } from './../core'
import { MODAL } from '../../../constants/widgetTypes'
import { useFormSuccessSelector, usePageDuration } from '../core/hooks'
import { GatingContext, ModalContext } from './../core'
import { Fonts } from '@paperflite-marketing/cleverstory-commons';


export const GatingManager = React.forwardRef(({ configurations, children, resetGating, page, breakpoint, preview }, ref) => {
  const context = React.useContext(WidgetsContext);

  const [gatingContext, setGatingContext] = React.useState({
    preview: preview,
    disabled: false,
    triggerGating: () => {},
    type: null,
    payload: null,
    gating: null,
    configuration: null,
    configurations: [],
    assetConfigurations: []
  });

  const [widgetContextState, setWidgetContextState] = React.useState({
    ...context
  });

  var formSuccess = useFormSuccessSelector(widgetContextState.selector);
  const duration = usePageDuration();

  useState(() => {
    setGatingContext((gatingContext) => {
      return {
        ...gatingContext,
        triggerGating: triggerGating
      }
    })
  }, []);

  React.useEffect(() => {
    if (gatingContext.gating) {
      setWidgetContextState(widgetContextState => {
        return {
          ...widgetContextState,
          ...context.createGatingContext(gatingContext.gating)
        }
      })
    }
  }, [gatingContext.gating])

  useEffect(() => {
    initiateGatingForTimeSpent();
  }, [duration]);

  useEffect(() => {
    setGatingContext((gatingContext) => {
      return {
        ...gatingContext,
        configurations: configurations
      }
    })
  }, [configurations]);

  useEffect(() => {
    if(formSuccess) {
      handleFormSuccess()
    }
  }, [formSuccess]);

  useEffect(() => {
    if(context) {
      setWidgetContextState(widgetContextState => {
        return {
          ...context,
          ...widgetContextState
        }
      })
    }
  }, [context])

  React.useImperativeHandle(ref, () => ({
    triggerGating: triggerGating,
    closeGating: handleClose
  }));

  const triggerGating = (type, payload, configuration) => {
    if (gatingContext.gating || gatingContext.disabled) {
      return;
    }

    var gating = _.get(configuration, 'gating.id');

    setGatingContext((gatingContext) => {
      return {
        ...gatingContext,
        gating: gating,
        type: type,
        payload: payload,
        configuration: configuration
      }
    })
  }

  const initiateGatingForTimeSpent = () => {
    if(gatingContext.gating || gatingContext.disabled || preview) {
      return;
    }

    var timeConfigurations = gatingContext.configurations.filter(item => {
      return _.get(item, 'trigger.type', null) === 'TIME';
    })

    timeConfigurations.every(item => {
      var triggerDuration = _.get(item, 'trigger.value', 0);

      if (triggerDuration <= duration) {
        var gating = _.get(item, 'gating.id', null);

        if (gating) {
          setGatingContext((gatingContext) => {
            return {
              ...gatingContext,
              gating: gating,
              type: 'TIME',
              payload: null,
              configuration: item
            }
          });

          return false;
        }
      }

      return true;
    })
  }

  const handleFormSuccess = () => {
    if(!preview) {
      if (gatingContext.type === 'INTERACTIVE_DOWNLOAD') {
        if (gatingContext.payload.download) {
          gatingContext.payload.download();
        }
      }
    }

    resetGating(page);

    setGatingContext((gatingContext) => {
      if (preview) {
        return {
          ...gatingContext,
          gating: null,
          configuration: null
        }
      }

      return {
        ...gatingContext,
        triggerGating: () => { },
        type: null,
        payload: null,
        gating: null,
        configuration: null,
        configurations: [],
        disabled: true
      }
    });
  }
  

  const handleClose = (configuration) => {
    if(!configuration) {
      return;
    }    
    var items = [...gatingContext.assetConfigurations, configuration.id]

    setGatingContext((gatingContext) => {
      return {
        ...gatingContext,
        gating: null,
        configuration: null,
        configurations: (gatingContext.configurations || []).filter(item => item.id !== configuration.id),
        assetConfigurations: items
      }
    })

    resetGating(page);
  }

  return (
    <GatingContext.Provider ref={ref} value={gatingContext}>
      {gatingContext.gating &&
        <GatingRender
          widgetContext={widgetContextState}
          configuration={gatingContext.configuration}
          gatingId={gatingContext.gating}
          show={gatingContext.gating !== null}
          onClose={handleClose}
          breakpoint={breakpoint}
          preview={preview} />
      }
      {children}
    </GatingContext.Provider>
  )
})

const GatingRender = ({ widgetContext, configuration, gatingId, show, onClose, breakpoint, preview }) => {

  const [modalContext, setModalContext] = React.useState({});

  const gating = useSelector(state => _.get(state, `gatings.gating[${gatingId}].item`, null));
  var widgets = _.get(gating, 'draft.widgets', [])
  if(!preview) {
    widgets = _.get(gating, 'content.widgets', []);

    const fonts = _.get(gating, `content.fonts`) || []
    Fonts.useFont(fonts);
  }

  const modalWidget = widgets.find((item) => item.type === MODAL);

  useEffect(() => {
    if(configuration && configuration.optional) {
      setModalContext((modalContext) => {
        return {
          ...modalContext,
          close: handleCloseGating
        }
      });
    }
  }, [configuration])

  const handleCloseGating = () => {
    if(onClose) {
      onClose(configuration);
    }
  }

  if (!modalWidget) {
    return null
  }

  return (
    <WidgetsContext.Provider value={widgetContext}>
      <ModalContext.Provider value={modalContext}>
          <Widget
            key={modalWidget.uid}
            widgetProps={modalWidget}
            breakpoint={breakpoint}
            show={show}
          />
      </ModalContext.Provider>
    </WidgetsContext.Provider>
  )
}
